/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP Calculator — Estimate Mutual Fund Returns | Toolverse`)
};

const es_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de SIP — Estima Retornos de Fondos Mutuales | Toolverse`)
};

const de_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP-Rechner — Schätzen Sie Investmentfonds-Renditen | Toolverse`)
};

const nl_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP-calculator — Schat rendement op beleggingsfondsen | Toolverse`)
};

const fr_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice SIP — Estimez les Rendements des Fonds Communs | Toolverse`)
};

const it_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore SIP — Stima i Rendimenti dei Fondi Comuni | Toolverse`)
};

const pt_br2_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora SIP — Estime Retornos de Fundos Mútuos | Toolverse`)
};

const pt_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de SIP — Estime Retornos de Fundos de Investimento | Toolverse`)
};

const ja_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP計算機 — 投資信託の返却額を推定 | Toolverse`)
};

const zh_sip_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP计算器——估算共同基金收益 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_hub_meta_title", locale)
	if (locale === "en") return en_sip_hub_meta_title(inputs)
	if (locale === "es") return es_sip_hub_meta_title(inputs)
	if (locale === "de") return de_sip_hub_meta_title(inputs)
	if (locale === "nl") return nl_sip_hub_meta_title(inputs)
	if (locale === "fr") return fr_sip_hub_meta_title(inputs)
	if (locale === "it") return it_sip_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sip_hub_meta_title(inputs)
	if (locale === "pt") return pt_sip_hub_meta_title(inputs)
	if (locale === "ja") return ja_sip_hub_meta_title(inputs)
	return zh_sip_hub_meta_title(inputs)
};